import React from 'react';
import { Box } from '@mui/material';

const G1 = '#9FE870', G2 = '#163300', G3 = '#4caf50', G4 = '#2e7d32', BG = '#f0faf0';
const R = ({ x, y, w, h, fill, rx = 3, opacity = 1, style }) => <rect x={x} y={y} width={w} height={h} rx={rx} fill={fill} opacity={opacity} style={style} />;
const T = ({ x, y, size = 6, fill = G2, weight = 400, opacity = 1, children }) => <text x={x} y={y} fontSize={size} fill={fill} fontWeight={weight} fontFamily="Inter,sans-serif" opacity={opacity}>{children}</text>;

const items = [
  { sku: 'SKU-001', name: 'Office Chair Pro',    qty: 142, min: 20,  value: '$18,460', status: 'OK'       },
  { sku: 'SKU-002', name: 'Standing Desk',        qty: 8,   min: 10,  value: '$4,200',  status: 'Low'      },
  { sku: 'SKU-003', name: 'Monitor 27"',          qty: 56,  min: 15,  value: '$22,400', status: 'OK'       },
  { sku: 'SKU-004', name: 'Keyboard Wireless',    qty: 3,   min: 10,  value: '$450',    status: 'Critical' },
  { sku: 'SKU-005', name: 'Webcam HD',            qty: 89,  min: 20,  value: '$8,900',  status: 'OK'       },
  { sku: 'SKU-006', name: 'USB-C Hub',            qty: 12,  min: 15,  value: '$1,440',  status: 'Low'      },
];

const statusColor = s => s === 'OK' ? G3 : s === 'Low' ? '#f59e0b' : '#ef4444';

const InventoryMockup = () => {
  const W = 480, H = 300;

  return (
    <Box sx={{ width: '100%', maxWidth: 520, position: 'relative', filter: 'drop-shadow(0 20px 40px rgba(22,51,0,0.20))', '& svg': { display: 'block', width: '100%', height: 'auto' } }}>
      <style>{`@keyframes ifU{from{opacity:0;transform:translateY(5px)}to{opacity:1;transform:translateY(0)}} @keyframes iBar{from{width:0}to{}}`}</style>
      <svg viewBox={`0 0 ${W} ${H}`} xmlns="http://www.w3.org/2000/svg">
        <defs><linearGradient id="ig" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="white" stopOpacity="0.06"/><stop offset="100%" stopColor="white" stopOpacity="0"/></linearGradient></defs>

        <R x={0} y={0} w={W} h={H} fill={BG} rx={12} />
        {/* chrome */}
        <R x={0} y={0} w={W} h={26} fill={G2} rx={12} />
        <R x={0} y={14} w={W} h={12} fill={G2} />
        <circle cx={13} cy={13} r={4} fill="#ff5f57" />
        <circle cx={25} cy={13} r={4} fill="#febc2e" />
        <circle cx={37} cy={13} r={4} fill="#28c840" />
        <T x={W/2-28} y={17} size={7} fill={G1} weight={700}>Inventory</T>

        {/* sidebar */}
        <R x={0} y={26} w={50} h={H-26} fill={G2} />
        <R x={12} y={34} w={26} h={26} fill={G1} rx={6} />
        <T x={18} y={51} size={9} fill={G2} weight={800}>F</T>
        {[
          { icon: '▦', label: 'Dash',    y: 74  },
          { icon: '⊞', label: 'Stock',   y: 94,  active: true },
          { icon: '◈', label: 'Items',   y: 114 },
          { icon: '↕', label: 'Moves',   y: 134 },
          { icon: '⊟', label: 'PO',      y: 154 },
          { icon: '≡', label: 'Reports', y: 174 },
        ].map(({ icon, label, y, active }) => (
          <g key={label}>
            {active && <R x={0} y={y-8} w={50} h={20} fill={G1} opacity={0.15} rx={0} />}
            {active && <R x={0} y={y-8} w={3}  h={20} fill={G1} rx={0} />}
            <T x={15} y={y+4}  size={8}   fill={active ? G1 : 'white'} opacity={active ? 1 : 0.4}>{icon}</T>
            <T x={8}  y={y+14} size={4.5} fill={active ? G1 : 'white'} opacity={active ? 1 : 0.3}>{label}</T>
          </g>
        ))}

        {/* topbar */}
        <R x={50} y={26} w={W-50} h={22} fill="white" opacity={0.55} />
        <T x={58} y={41} size={7} fill={G2} weight={700}>Stock Overview</T>
        {/* warehouse tabs */}
        {['All', 'WH-01', 'WH-02', 'WH-03'].map((wh, i) => (
          <g key={wh}>
            <R x={W-170+i*38} y={30} w={34} h={13} fill={i===0 ? G2 : BG} rx={6} opacity={i===0?0.9:0.6} />
            <T x={W-165+i*38} y={40} size={5.5} fill={i===0?G1:G2} weight={i===0?700:400}>{wh}</T>
          </g>
        ))}

        {/* stat cards */}
        {[
          { label: 'Total SKUs',   value: '1,284', color: G3,        x: 56  },
          { label: 'Low Stock',    value: '14',    color: '#f59e0b', x: 140 },
          { label: 'Out of Stock', value: '3',     color: '#ef4444', x: 224 },
          { label: 'Stock Value',  value: '$284K', color: G4,        x: 308 },
        ].map(({ label, value, color, x }, i) => (
          <g key={label} style={{ animation: `ifU 0.5s ${0.1+i*0.1}s ease both` }}>
            <R x={x} y={52} w={78} h={38} fill="white" rx={5} />
            <R x={x} y={52} w={3}  h={38} fill={color} rx={2} />
            <T x={x+7} y={64} size={5.5} fill={G2} opacity={0.5}>{label}</T>
            <T x={x+7} y={80} size={9}   fill={G2} weight={700}>{value}</T>
          </g>
        ))}

        {/* table header */}
        <R x={56} y={96} w={W-62} h={13} fill={G2} rx={3} opacity={0.07} />
        <T x={62}  y={106} size={5.5} fill={G2} weight={700} opacity={0.5}>SKU</T>
        <T x={100} y={106} size={5.5} fill={G2} weight={700} opacity={0.5}>ITEM NAME</T>
        <T x={240} y={106} size={5.5} fill={G2} weight={700} opacity={0.5}>QTY</T>
        <T x={290} y={106} size={5.5} fill={G2} weight={700} opacity={0.5}>STOCK LEVEL</T>
        <T x={390} y={106} size={5.5} fill={G2} weight={700} opacity={0.5}>STATUS</T>

        {items.map((item, i) => {
          const pct = Math.min(item.qty / (item.min * 8), 1);
          const sc  = statusColor(item.status);
          return (
            <g key={item.sku} style={{ animation: `ifU 0.4s ${0.1+i*0.08}s ease both` }}>
              <R x={56} y={111+i*26} w={W-62} h={22} fill="white" rx={3} opacity={i%2===0?0.8:0.5} />
              <T x={62}  y={126+i*26} size={5.5} fill={G2} weight={600}>{item.sku}</T>
              <T x={100} y={126+i*26} size={6}   fill={G2}>{item.name}</T>
              <T x={240} y={126+i*26} size={6}   fill={G2} weight={600}>{item.qty}</T>
              {/* stock bar */}
              <R x={288} y={117+i*26} w={80} h={8} fill={G2} rx={4} opacity={0.08} />
              <R x={288} y={117+i*26} w={Math.round(80*pct)} h={8} fill={sc} rx={4}
                style={{ animation: `ifU 0.6s ${0.2+i*0.08}s ease both` }} />
              {/* status badge */}
              <R x={385} y={114+i*26} w={40} h={12} fill={sc} rx={6} opacity={0.15} />
              <T x={390} y={124+i*26} size={5.5} fill={sc} weight={700}>{item.status}</T>
            </g>
          );
        })}

        <R x={0} y={0} w={W} h={H} fill="url(#ig)" rx={12} />
      </svg>
      <Box aria-hidden sx={{ position:'absolute', inset:'-1px', borderRadius:'13px', border:'1px solid rgba(22,51,0,0.10)', pointerEvents:'none' }} />
    </Box>
  );
};

export default InventoryMockup;
